/* VSKLO cart mutation queue — one Shopify cart writer at a time. */
(function () {
  'use strict';
  if (window.VSKLOCartMutationQueue) return;

  var tail = Promise.resolve();
  var pending = 0;

  function enqueue(label, task) {
    if (typeof task !== 'function') return Promise.reject(new TypeError('Cart mutation task must be a function'));
    pending += 1;
    var run = function () { return Promise.resolve().then(task); };
    var result = tail.then(run, run);
    tail = result.catch(function (error) {
      console.error('[VSKLO cart mutation]', label || 'mutation', error);
    }).finally(function () {
      pending = Math.max(0, pending - 1);
    });
    return result;
  }

  function whenIdle() {
    var observedTail = tail;
    return observedTail.then(function () {
      // A mutation may have been enqueued while the caller was waiting for the
      // previous tail. Re-check both the tail identity and pending count so
      // checkout/navigation never proceeds on a stale queue snapshot.
      if (observedTail !== tail || pending > 0) return whenIdle();
      return true;
    });
  }

  window.VSKLOCartMutationQueue = {
    enqueue: enqueue,
    whenIdle: whenIdle,
    hasPending: function () { return pending > 0; }
  };
})();